import { faCartShopping } from '@fortawesome/free-solid-svg-icons'
import React, { useCallback } from 'react'
import { Colors } from '../../../../utils/colors/colors'
import { NotificationProps } from '../../FactoryNotification/FactoryNotification'
import GenericNotification from '../GenericNotification'


interface NewProductAcceptedNotificationProps extends NotificationProps {
	item: {
		id: string,
		notifMsg: string,
		timestamp: number,
		viewed: boolean,
		notifData: {
			approved: string,
			receivedFromType: string,
			userName: string,
			transactionId: string
		},
	}
}


const NewProductAcceptedNotification = ({ item, clickable, onSetNotificationAsView }: NewProductAcceptedNotificationProps) => {
	const { id, notifMsg, timestamp, viewed, notifData: { approved } } = item

	const touchNotification = useCallback(
		() => {
			if (!viewed)
				onSetNotificationAsView(id)
		},
		[],
	)

	return (
		<GenericNotification
			touchNotification={touchNotification}


			id={id}
			timestamp={timestamp}
			viewed={clickable ? viewed : true}
			description={"New product accepted"}
			title={"Username accepts your product"}

			icon={faCartShopping}
			color={Colors.flagGreen}
		/>
	)
}

export default React.memo(NewProductAcceptedNotification)